export default {
  "achievement_title": {
    "HK": "成就",
    "TW": "成就",
    "ar_SA": "الإنجازات",
    "de_DE": "Achievements",
    "en_US": "Achievements",
    "es_ES": "Logros",
    "fr_FR": "Succès",
    "hi_IN": "Achievements",
    "in_ID": "Prestasi",
    "ja_JP": "実績",
    "ko_KR": "업적",
    "ms_MY": "Pencapaian",
    "pt_PT": "Conquistas",
    "ru_RU": "Достижения",
    "th_TH": "ความสำเร็จ",
    "tr_TR": "Başarımlar",
    "vi_VN": "Thành tích",
    "zh_CN": "成就"
  },
  "club_achievement_1": {
    "HK": "恭喜你！你建立的俱樂部%s達到%s成員成就！",
    "TW": "恭喜您！您建立的俱樂部%s達成%s成員成就！",
    "ar_SA": "تهانينا! وصل النادي%s الذي أنشأته إلى تحرير الإنجازات لتحقيق %s من الأعضاء!",
    "de_DE": "Herzlichen Glückwunsch! Der von dir gegründete Club %s hat das Achievement für „%s Mitglieder“ freigeschaltet!",
    "en_US": "Congratulations! The club you created, %s, has unlocked the achievement for reaching %s members!",
    "es_ES": "¡Felicidades! ¡El club que creaste, %s, ha desbloqueado el logro por llegar a %s miembros!",
    "fr_FR": "Félicitations ! Le club que vous avez créé, %s, a débloqué le succès pour avoir atteint %s membres !",
    "hi_IN": "Congratulations! The club you created, %s, has unlocked the achievement for reaching %s members!",
    "in_ID": "Selamat! Klub yang kamu buat, %s, telah membuka prestasi setelah mencapai %s anggota!",
    "ja_JP": "おめでとう！ あなたが作成したクラブ %s は、%s メンバーに到達するための実績を解除しました!",
    "ko_KR": "축하해요! 귀하가 만든 클럽 %s이(가) %s 회원 달성 달성을 달성했습니다!",
    "ms_MY": "Tahniah! Kelab yang anda cipta iaitu %s telah membuka pencapaian kerana mencapai %s ahli!",
    "pt_PT": "Parabéns! O clube que você criou, %s, desbloqueou a conquista por alcançar %s membros!",
    "ru_RU": "Поздравляем! В вашем клубе «%s» уже %s участников! Открыто достижение!",
    "th_TH": "ยินดีด้วย! คลับ %s ที่คุณสร้างปลดล็อคความสำเร็จเนื่องจากมีสมาชิกครบ %s คน!",
    "tr_TR": "Tebrikler! Oluşturduğun %s kulübü, %s oyuncuya ulaşarak başarım kazandı!",
    "vi_VN": "Xin chúc mừng! Câu Lạc Bộ %s do bạn sáng lập đã đạt %s thành viên!",
    "zh_CN": "恭喜你！你创建的俱乐部%s达到了%s成员成就！"
  },
  "club_achievement_2": {
    "HK": "恭喜你！解鎖了新建俱樂部成就：%s ！",
    "TW": "恭喜您！解鎖了建立新俱樂部成就：%s！",
    "ar_SA": "تهانينا! تم تحرير إنجاز إنشاء النادي الجديد: %s!",
    "de_DE": "Glückwunsch! Du hast das neue Clubgründungs-Achievement: %s freigeschaltet!",
    "en_US": "Congratulations! Unlocked the new club creation achievement: %s!",
    "es_ES": "¡Felicidades! ¡Desbloqueaste el nuevo logro de creación de clubes: %s!",
    "fr_FR": "Félicitations ! Vous avez débloqué le succès de création de club : %s !",
    "hi_IN": "Congratulations! Unlocked the new club creation achievement: %s!",
    "in_ID": "Selamat! Pencapaian klub baru dibuka: %s!",
    "ja_JP": "おめでとう！ 新しいクラブ作成実績のロックを解除しました: %s!",
    "ko_KR": "축하해요! 새 클럽 만들기 업적 달성: %s!",
    "ms_MY": "Tahniah! Anda membuka pencapaian ciptaan kelab baharu: %s!",
    "pt_PT": "Parabéns! Desbloqueou a conquista de criação de novo clube: %s!",
    "ru_RU": "Поздравляем с достижением за создание клуба «%s»!",
    "th_TH": "ยินดีด้วย! ปลดล็อคความสำเร็จการสร้างคลับใหม่: %s!",
    "tr_TR": "Tebrikler! Yeni kulüp oluşturma başarımını kazandın: %s!",
    "vi_VN": "Xin chúc mừng! Bạn đã mở khóa thành tích sáng lập Câu Lạc Bộ Mới: %s!",
    "zh_CN": "恭喜你！解锁了新建俱乐部成就：%s ！"
  },
  "club_achievement_3": {
    "HK": "恭喜你！解鎖了動態發佈獲得讚好總數%s成就！",
    "TW": "恭喜您！解鎖了動態發佈獲得按讚總數%s成就！",
    "ar_SA": "تهانينا! تم تحرير الإنجاز لبلوغ %s من إجمالي الإعجابات للمنشور!",
    "de_DE": "Glückwunsch! Du hast das Achievement fürs Erreichen von %s Gesamt-LIKEs für Beiträge freigeschaltet!",
    "en_US": "Congratulations! Unlocked the achievement for reaching %s total post LIKEs!",
    "es_ES": "¡Felicidades! ¡Desbloqueaste el logro por alcanzar %s ME GUSTA en publicaciones!",
    "fr_FR": "Félicitations ! Vous avez débloqué le succès pour avoir reçu un total de %s LIKES sur vos billets !",
    "hi_IN": "Congratulations! Unlocked the achievement for reaching %s total post LIKEs!",
    "in_ID": "Selamat! Berhasil membuka prestasi setelah mencapai %s total LIKE postingan!",
    "ja_JP": "おめでとう！ 合計 %s の投稿のいいね! に到達した実績のロックを解除しました!",
    "ko_KR": "축하해요! 총 %s개의 게시물에 LIKE를 달성하여 업적을 잠금 해제했습니다!",
    "ms_MY": "Tahniah! Anda membuka pencapaian kerana mencapai sejumlah %s SUKA siaran!",
    "pt_PT": "Parabéns! Desbloqueou a conquista por atingir o total de %s CURTIDAS de postagens!",
    "ru_RU": "Поздравляем с достижением! Вы получили %s лайков за сообщения!",
    "th_TH": "ยินดีด้วย! ปลดล็อคความสำเร็จเนื่องจากมียอดไลก์โพสต์รวมครบ %s!",
    "tr_TR": "Tebrikler! Paylaşımlarının toplamda %s beğeniye ulaşma başarımını kazandın!",
    "vi_VN": "Xin chúc mừng! Bạn đã mở khóa thành tích đạt %s lượt THÍCH cho các bài đăng!",
    "zh_CN": "恭喜你！解锁了动态发布获赞总数%s成就！"
  },
  "club_achievement_4": {
    "HK": "恭喜你！解鎖了動態發佈%s篇成就！",
    "TW": "恭喜您！解鎖了動態發佈%s篇成就！",
    "ar_SA": "تهانينا! تم تحرير الإنجاز لبلوغ إجمالي %s من المشاركات!",
    "de_DE": "Glückwunsch! Du hast das Achievement fürs Erreichen von %s Gesamt-Beiträgen freigeschaltet!",
    "en_US": "Congratulations! Unlocked the achievement for reaching %s total posts!",
    "es_ES": "¡Felicidades! ¡Desbloqueaste el logro por alcanzar %s publicaciones totales!",
    "fr_FR": "Félicitations ! Vous avez débloqué le succès pour avoir publié %s billets !",
    "hi_IN": "Congratulations! Unlocked the achievement for reaching %s total posts!",
    "in_ID": "Selamat! Berhasil membuka prestasi setelah mencapai total %s postingan!",
    "ja_JP": "おめでとう！ 合計投稿数 %s に到達した実績をアンロックしました!",
    "ko_KR": "축하해요! 총 %s개의 게시물에 도달하여 업적을 잠금 해제했습니다!",
    "ms_MY": "Tahniah! Anda membuka pencapaian kerana mencapai sejumlah %s siaran!",
    "pt_PT": "Parabéns! Desbloqueou a conquista por atingir o total de %s postagens!",
    "ru_RU": "Поздравляем с достижением! Вы написали %s сообщений!",
    "th_TH": "ยินดีด้วย! ปลดล็อคความสำเร็จเนื่องจากจำนวนโพสต์รวมครบ %s!",
    "tr_TR": "Tebrikler! Toplamda %s paylaşıma ulaşma başarımını kazandın!",
    "vi_VN": "Xin chúc mừng! Bạn đã mở khóa thành tích đạt %s bài đăng!",
    "zh_CN": "恭喜你！解锁了动态发布%s篇成就！"
  },
  "club_achievement_5": {
    "HK": "恭喜你！你發佈的「%s」解鎖了%s讚好成就！",
    "TW": "恭喜您！您發佈的「%s」解鎖了%s按讚成就！",
    "ar_SA": "تهانينا! حرر منشورك \"%s\" للتو الإنجاز لبلوغ %s من الإعجابات!",
    "de_DE": "Glückwunsch! Dein Beitrag „%s“ hat soeben das Achievement für das Erreichen von %s LIKEs freigeschaltet!",
    "en_US": "Congratulations! Your post, \"%s,\" just unlocked the achievement for reaching %s LIKEs!",
    "es_ES": "¡Felicidades! ¡Tu publicación, \"%s\", acaba de desbloquear el logro por alcanzar %s ME GUSTA!",
    "fr_FR": "Félicitations ! Votre billet, %s, a débloqué le succès pour avoir reçu %s LIKES !",
    "hi_IN": "Congratulations! Your post, \"%s,\" just unlocked the achievement for reaching %s LIKEs!",
    "in_ID": "Selamat! Postingan kamu, \"%s\", baru saja membuka prestasi setelah mencapai %s SUKA!",
    "ja_JP": "おめでとう！ あなたの投稿「%s」は、%s の「いいね!」に達した実績のロックを解除しました!",
    "ko_KR": "축하해요! 귀하의 게시물 \"%s\"이(가) %s LIKEs 달성 업적을 달성했습니다!",
    "ms_MY": "Tahniah! Siaran anda iaitu \"%s\" baru membuka pencapaian kerana mencapai %s SUKA!",
    "pt_PT": "Parabéns! Sua postagem, \"%s\", acabou de desbloquear a conquista por alcançar %s CURTIDAS!",
    "ru_RU": "Поздравляем с достижением! Ваше сообщение «%s» получило %s лайков!",
    "th_TH": "ยินดีด้วย! โพสต์ \"%s\" ของคุณเพิ่งปลดล็อคความสำเร็จเนื่องจากมียอดไลก์ครบ %s!",
    "tr_TR": "Tebrikler! \"%s\" paylaşımın %s beğeniye ulaşarak yeni bir başarım kazandı!",
    "vi_VN": "Xin chúc mừng! Bài đăng của bạn \"%s\" đã mở khóa thành tích đạt %s lượt THÍCH!",
    "zh_CN": "恭喜你！你发布的“%s”解锁了%s点赞成就！"
  },
  "club_achievement_6": {
    "HK": "恭喜你！你獲得了%s珍貴勳章！",
    "TW": "恭喜您！您獲得了%s珍貴勳章！",
    "ar_SA": "تهانينا! حصلت على شارة قيِّمة: %s!",
    "de_DE": "Glückwunsch! Du hast das folgende wertvolle Abzeichen erhalten: %s",
    "en_US": "Congratulations! You got the valuable Badge: %s!",
    "es_ES": "Congratulations! You got the valuable Badge: %s!",
    "fr_FR": "Félicitations ! Vous avez obtenu le précieux insigne : %s ! ",
    "hi_IN": "Congratulations! You got the valuable Badge: %s!",
    "in_ID": "Selamat! Kamu mendapatkan Lencana yang berharga: %s!",
    "ja_JP": "おめでとう！ 貴重なバッジを獲得しました: %s!",
    "ko_KR": "축하해요! 귀중한 배지를 얻었습니다: %s!",
    "ms_MY": "Tahniah! Anda mendapat Lencana bernilai: %s!",
    "pt_PT": "Parabéns! Você recebeu o valioso Emblema: %s!",
    "ru_RU": "Поздравляем! Вы получили эмблему «%s»!",
    "th_TH": "ยินดีด้วย! คุณได้รับตราประทับที่ล้ำค่า: %s!",
    "tr_TR": "Tebrikler! Değerli bir Rozet kazandın: %s!",
    "vi_VN": "Xin chúc mừng! Bạn nhận được Huy Hiệu giá trị: %s!",
    "zh_CN": "恭喜你！你获得了%s珍贵勋章！"
  },
  "club_achievement_club": {
    "HK": "俱樂部成就",
    "TW": "俱樂部成就",
    "ar_SA": "إنجازات النادي",
    "de_DE": "Club-Achievements",
    "en_US": "Club Achievements",
    "es_ES": "Logros del Club",
    "fr_FR": "Succès de club",
    "hi_IN": "Club Achievements",
    "in_ID": "Prestasi Klub",
    "ja_JP": "クラブの実績",
    "ko_KR": "클럽 성과",
    "ms_MY": "Pencapaian Kelab",
    "pt_PT": "Conquistas de Clube",
    "ru_RU": "Достижения клуба",
    "th_TH": "ความสำเร็จคลับ",
    "tr_TR": "Kulüp Başarımları",
    "vi_VN": "Thành Tích Câu Lạc Bộ",
    "zh_CN": "俱乐部成就"
  },
  "club_achievement_list_title": {
    "HK": "里程碑",
    "TW": "里程碑",
    "ar_SA": "الإنجاز",
    "de_DE": "Meilenstein",
    "en_US": "Milestone",
    "es_ES": "Hitos",
    "fr_FR": "Seuil",
    "hi_IN": "Milestone",
    "in_ID": "Milestone",
    "ja_JP": "Milestone",
    "ko_KR": "Milestone",
    "ms_MY": "Titik Capai",
    "pt_PT": "Marco",
    "ru_RU": "Цели",
    "th_TH": "ไมล์สโตน",
    "tr_TR": "Hedef",
    "vi_VN": "Mốc",
    "zh_CN": "里程碑"
  },
  "club_achievement_medal": {
    "HK": "勳章成就",
    "TW": "勳章成就",
    "ar_SA": "إنجازات الشارة",
    "de_DE": "Abzeichen-Achievement",
    "en_US": "Badge Achievement",
    "es_ES": "Badge Achievement",
    "fr_FR": "Succès d'insignes",
    "hi_IN": "Badge Achievement",
    "in_ID": "Prestasi Lencana",
    "ja_JP": "バッジアチーブメント",
    "ko_KR": "배지 달성",
    "ms_MY": "Pencapaian Lencana",
    "pt_PT": "Conquista de Emblema",
    "ru_RU": "Эмблема за достижения",
    "th_TH": "ความสำเร็จตราประทับ",
    "tr_TR": "Rozet Başarımı",
    "vi_VN": "Thành Tích Huy Hiệu",
    "zh_CN": "勋章成就"
  },
  "club_achievement_next_level": {
    "HK": "下一等級",
    "TW": "下一等級",
    "ar_SA": "المستوى التالي",
    "de_DE": "Nächster Level",
    "en_US": "Next Level",
    "es_ES": "Siguiente Nivel",
    "fr_FR": "Niveau suivant",
    "hi_IN": "Next Level",
    "in_ID": "Level Selanjutnya",
    "ja_JP": "次のレベル",
    "ko_KR": "다음 레벨",
    "ms_MY": "Tahap Seterusnya",
    "pt_PT": "Nível Seguinte",
    "ru_RU": "Следующий уровень",
    "th_TH": "เลเวลต่อไป",
    "tr_TR": "Sonraki Seviye",
    "vi_VN": "Cấp Tiếp Theo",
    "zh_CN": "下一等级"
  },
  "club_achievement_overview_close": {
    "HK": "收起",
    "TW": "收起",
    "ar_SA": "طي",
    "de_DE": "Einklappen",
    "en_US": "Collapse",
    "es_ES": "Contraer",
    "fr_FR": "Réduire",
    "hi_IN": "Collapse",
    "in_ID": "Tutup",
    "ja_JP": "Collapse",
    "ko_KR": "Collapse",
    "ms_MY": "Ranap",
    "pt_PT": "Minimizar",
    "ru_RU": "Свернуть",
    "th_TH": "ย่อ",
    "tr_TR": "Daralt",
    "vi_VN": "Thu gọn",
    "zh_CN": "收起"
  },
  "club_achievement_overview_condition_10": {
    "HK": "在俱樂部內，當月帖文獲得讚好數達到1,000，每月更新可重複完成",
    "TW": "在俱樂部內，當月發文獲得按讚數達到1,000，每月更新可重複完成",
    "ar_SA": "اكتسب ألف إعجاب على المنشورات في النادي خلال شهر واحد. يمكن إكمال هذا الإنجاز شهريًا.",
    "de_DE": "Erhalte 1000 LIKEs durch Beiträge im Club innerhalb eines Kalendermonats. Kann jeden Monat abgeschlossen werden.",
    "en_US": "Get 1,000 LIKEs from posts in Club in a calendar month. Can be completed every month.",
    "es_ES": "Obtén 1000 ME GUSTA en comentarios en el Club en un mes calendario. Se puede completar cada mes.",
    "fr_FR": "Obtenez 1 000 LIKES sur vos billets dans le Club au cours d'un mois calendaire. Peut être accompli chaque mois.",
    "hi_IN": "Get 1,000 LIKEs from posts in Club in a calendar month. Can be completed every month.",
    "in_ID": "Dapatkan 1.000 SUKA dari postingan di Club dalam satu bulan kalender. Bisa diselesaikan setiap bulan.",
    "ja_JP": "Get 1,000 LIKEs from posts in Club in a calendar month. Can be completed every month.",
    "ko_KR": "Get 1,000 LIKEs from posts in Club in a calendar month. Can be completed every month.",
    "ms_MY": "Dapatkan 1,000 SUKA daripada siaran dalam Kelab dalam bulan kalendar. Boleh dilengkapkan setiap bulan.",
    "pt_PT": "Receba 1.000 CURTIDAs de publicações no Clube em um mesmo mês. Pode ser obtida em cada mês.",
    "ru_RU": "Получите 1000 лайков за публикации в клубе в течение календарного месяца. Можно достигать каждый месяц.",
    "th_TH": "ได้รับ 1,000 ไลก์จากโพสต์ในคลับภายในระยะเวลาหนึ่งเดือนตามปฏิทิน โดยสามารถบรรลุได้ทุกเดือน",
    "tr_TR": "Bir takvim ayı içinde Kulüp'teki gönderilerinden 1000 Beğeni al. Her ay tamamlanabilir.",
    "vi_VN": "Nhận 1,000 LIKE cho bài đăng trong Câu Lạc Bộ trong tháng. Có thể hoàn thành mỗi tháng.",
    "zh_CN": "在俱乐部内，自然月发帖获得的赞数达到1,000，每月更新可重复完成"
  },
  "club_achievement_overview_condition_11": {
    "HK": "在俱樂部內，累積獲得1,000名追蹤者",
    "TW": "在俱樂部內，累計獲得1,000名追蹤者",
    "ar_SA": "اكتسب ألف متابع في النادي.",
    "de_DE": "Erreiche 1000 Follower im Club.",
    "en_US": "Reach 1,000 followers in Club.",
    "es_ES": "Alcanza 1000 seguidores en el Club.",
    "fr_FR": "Atteignez 1 000 abonnés dans le Club.",
    "hi_IN": "Reach 1,000 followers in Club.",
    "in_ID": "Capai 1.000 pengikut di Club.",
    "ja_JP": "Reach 1,000 followers in Club.",
    "ko_KR": "Reach 1,000 followers in Club.",
    "ms_MY": "Capai 1,000 pengikut dalam Kelab.",
    "pt_PT": "Alcance 1.000 seguidores no Clube.",
    "ru_RU": "Наберите 1000 подписчиков в клубе.",
    "th_TH": "มีผู้ติดตามในคลับครบ 1,000 คน",
    "tr_TR": "Kulüp'te 1000 takipçiye ulaş.",
    "vi_VN": "Có 1,000 người theo dõi trong Câu Lạc Bộ.",
    "zh_CN": "在俱乐部内，累计获得1,000名关注者"
  },
  "club_achievement_overview_condition_12": {
    "HK": "在俱樂部內，累積獲得100,000名追蹤者",
    "TW": "在俱樂部內，累計獲得100,000名追蹤者",
    "ar_SA": "اكتسب 100 ألف متابع في النادي.",
    "de_DE": "Erreiche 100000 Follower im Club.",
    "en_US": "Reach 100,000 followers in Club.",
    "es_ES": "Alcanza 100 000 seguidores en el Club.",
    "fr_FR": "Atteignez 100 000 abonnés dans le Club.",
    "hi_IN": "Reach 100,000 followers in Club.",
    "in_ID": "Capai 100.000 pengikut di Club.",
    "ja_JP": "Reach 100,000 followers in Club.",
    "ko_KR": "Reach 100,000 followers in Club.",
    "ms_MY": "Capai 100,000 pengikut dalam Kelab.",
    "pt_PT": "Alcance 100.000 seguidores no Clube.",
    "ru_RU": "Наберите 100 000 подписчиков в клубе.",
    "th_TH": "มีผู้ติดตามในคลับครบ 100,000 คน",
    "tr_TR": "Kulüp'te 100.000 takipçiye ulaş.",
    "vi_VN": "Có 100,000 người theo dõi trong Câu Lạc Bộ.",
    "zh_CN": "在俱乐部内，累计获得100,000名关注者"
  },
  "club_achievement_overview_condition_6": {
    "HK": "在俱樂部內，帖文累積獲得讚好數達到1,000",
    "TW": "在俱樂部內，發文累計獲得按讚數達到1,000",
    "ar_SA": "اكتسب ألف إعجاب إجمالًا على منشوراتك في النادي.",
    "de_DE": "Erhalte insgesamt 1000 LIKEs durch Beiträge im Club.",
    "en_US": "Get a total of 1,000 LIKEs from posts in Club.",
    "es_ES": "Obtén un total de 1000 ME GUSTA en tus publicaciones del Club.",
    "fr_FR": "Obtenez un total de 1 000 LIKES sur vos billets dans le Club.",
    "hi_IN": "Get a total of 1,000 LIKEs from posts in Club.",
    "in_ID": "Dapatkan total 1.000 SUKA dari postingan di Club.",
    "ja_JP": "Get a total of 1,000 LIKEs from posts in Club.",
    "ko_KR": "Get a total of 1,000 LIKEs from posts in Club.",
    "ms_MY": "Dapatkan sejumlah 1,000 SUKA daripada siaran dalam Kelab.",
    "pt_PT": "Receba um total de 1.000 CURTIDAs de publicações no Clube.",
    "ru_RU": "Получите 1000 лайков за публикации в клубе.",
    "th_TH": "ได้รับรวม 1,000 ไลก์จากโพสต์ในคลับ",
    "tr_TR": "Kulüp'teki gönderilerden toplamda 1000 Beğeni al.",
    "vi_VN": "Nhận 1000 lượt THÍCH cho bài đăng trong Câu Lạc Bộ.",
    "zh_CN": "在俱乐部内，发帖累计获得的点赞数达到1,000"
  },
  "club_achievement_overview_condition_7": {
    "HK": "在俱樂部內，累積獲得10,000名追蹤者",
    "TW": "在俱樂部內，累計獲得10,000名追蹤者",
    "ar_SA": "اكتسب 10 آلاف متابع في النادي.",
    "de_DE": "Erreiche 10000 Follower im Club.",
    "en_US": "Reach 10,000 followers in Club.",
    "es_ES": "Alcanza 10 000 seguidores en el Club.",
    "fr_FR": "Atteignez 10 000 abonnés dans le Club.",
    "hi_IN": "Reach 10,000 followers in Club.",
    "in_ID": "Capai 10.000 pengikut di Club.",
    "ja_JP": "Reach 10,000 followers in Club.",
    "ko_KR": "Reach 10,000 followers in Club.",
    "ms_MY": "Capai 10,000 pengikut dalam Kelab.",
    "pt_PT": "Alcance 10.000 seguidores no Clube.",
    "ru_RU": "Наберите 10 000 подписчиков в клубе.",
    "th_TH": "มีผู้ติดตามในคลับครบ 10,000 คน",
    "tr_TR": "Kulüp'te 10.000 takipçiye ulaş.",
    "vi_VN": "Có 10,000 người theo dõi trong Câu Lạc Bộ.",
    "zh_CN": "在俱乐部内，累计获得10,000名关注者"
  },
  "club_achievement_overview_condition_8": {
    "HK": "在俱樂部內，當月發表的評論獲得讚好數達到200，每月更新可重複完成",
    "TW": "在俱樂部內，當月發表的評論獲得按讚數達到200，每月更新可重複完成",
    "ar_SA": "اكتسب 200 إعجاب على تعليقاتك في النادي خلال شهر واحد. يمكن إكمال هذا الإنجاز شهريًا.",
    "de_DE": "Erhalte 200 LIKEs durch Kommentare im Club innerhalb eines Kalendermonats. Kann jeden Monat abgeschlossen werden.",
    "en_US": "Get 200 LIKEs from comments in Club in a calendar month. Can be completed every month.",
    "es_ES": "Obtén 200 ME GUSTA en comentarios en el Club en un mes calendario. Se puede completar cada mes.",
    "fr_FR": "Obtenez 200 LIKES sur vos commentaires dans le Club au cours d'un mois calendaire. Peut être accompli chaque mois.",
    "hi_IN": "Get 200 LIKEs from comments in Club in a calendar month. Can be completed every month.",
    "in_ID": "Dapatkan 200 LIKE dari komentar di Club dalam satu bulan kalender. Bisa dituntaskan setiap bulan.",
    "ja_JP": "Get 200 LIKEs from comments in Club in a calendar month. Can be completed every month.",
    "ko_KR": "Get 200 LIKEs from comments in Club in a calendar month. Can be completed every month.",
    "ms_MY": "Dapatkan 200 SUKA daripada komen dalam Kelab dalam bulan kalendar. Boleh dilengkapkan setiap bulan.",
    "pt_PT": "Receba 200 CURTIDAs de comentários no Clube em um mesmo mês. Pode ser obtida em cada mês.",
    "ru_RU": "Получите 200 лайков за комментарии в клубе в течение календарного месяца. Можно достигать каждый месяц.",
    "th_TH": "ได้รับ 200 ไลก์จากคอมเมนท์ในคลับภายในระยะเวลาหนึ่งเดือนตามปฏิทิน โดยสามารถบรรลุได้ทุกเดือน",
    "tr_TR": "Bir takvim ayı içinde Kulüp'teki yorumlarından 200 Beğeni al. Her ay tamamlanabilir.",
    "vi_VN": "Nhận 200 lượt THÍCH cho các bình luận trong Câu Lạc Bộ trong tháng. Có thể hoàn thành mỗi tháng.",
    "zh_CN": "在俱乐部内，自然月发表的评论获赞达到200，每月更新可重复完成"
  },
  "club_achievement_overview_condition_9": {
    "HK": "在俱樂部內，當月帖文獲得的禮物人氣值達到10萬，每月更新可重複完成",
    "TW": "在俱樂部內，當月發文獲得的禮物人氣值達到10萬，每月更新可重複完成",
    "ar_SA": "اكتسب 100 ألف من الشعبية من هدايا المنشورات في النادي خلال شهر واحد. يمكن إكمال هذا الإنجاز شهريًا.",
    "de_DE": "Erhalte 100000 Beliebtheit durch Geschenke im Club innerhalb eines Kalendermonats. Kann jeden Monat abgeschlossen werden.",
    "en_US": "Get 100,000 Popularity from gifts for posts in Club in a calendar month. Can be completed every month.",
    "es_ES": "Obtén 100 000 de Popularidad en regalos por tus publicaciones en el Club en un mes calendario. Se puede completar cada mes.",
    "fr_FR": "Obtenez 100 000 de popularité grâce à des cadeaux pour vos billets dans le Club au cours d'un mois calendaire. Peut être accompli chaque mois.",
    "hi_IN": "Get 100,000 Popularity from gifts for posts in Club in a calendar month. Can be completed every month.",
    "in_ID": "Dapatkan 100.000 Popularitas dari hadiah untuk postingan di Club dalam satu bulan kalender. Bisa diselesaikan setiap bulan.",
    "ja_JP": "Get 100,000 Popularity from gifts for posts in Club in a calendar month. Can be completed every month.",
    "ko_KR": "Get 100,000 Popularity from gifts for posts in Club in a calendar month. Can be completed every month.",
    "ms_MY": "Dapatkan 100,000 Populariti daripada hadiah untuk siaran dalam Kelab dalam bulan kalendar. Boleh dilengkapkan setiap bulan.",
    "pt_PT": "Ganhe 100.000 de Popularidade de presentes por publicações no Clube em um mesmo mês. Pode ser obtida em cada mês.",
    "ru_RU": "Получите 100 000 ед. популярности от подарков за публикации в клубе в течение календарного месяца. Можно достигать каждый месяц.",
    "th_TH": "รับความนิยมครบ 100,000 จากของขวัญสำหรับโพสต์ในคลับภายในระยะเวลาหนึ่งเดือนตามปฏิทิน โดยสามารถบรรลุได้ทุกเดือน",
    "tr_TR": "Bir takvim ayı içinde Kulüp'teki gönderiler için hediyelerden 100.000 Popülerlik kazan. Her ay tamamlanabilir.",
    "vi_VN": "Nhận 100,000 Điểm Nổi Tiếng từ quà tặng cho bài đăng trong Câu Lạc Bộ trong tháng. Có thể hoàn thành mỗi tháng.",
    "zh_CN": "在俱乐部内，自然月发帖获得的礼物人气值达到10万，每月更新可重复完成"
  },
  "club_achievement_overview_know": {
    "HK": "知道了",
    "TW": "知道了",
    "ar_SA": "حسنًا",
    "de_DE": "Alles klar",
    "en_US": "Got It",
    "es_ES": "Entendido",
    "fr_FR": "OK",
    "hi_IN": "Got It",
    "in_ID": "Mengerti",
    "ja_JP": "Got It",
    "ko_KR": "Got It",
    "ms_MY": "Faham",
    "pt_PT": "Obtive",
    "ru_RU": "Ясно",
    "th_TH": "รับทราบ",
    "tr_TR": "Tamam",
    "vi_VN": "Đã Rõ",
    "zh_CN": "知道了"
  },
  "club_achievement_overview_monthly": {
    "HK": "每月更新",
    "TW": "每月更新",
    "ar_SA": "يُحدّث شهريًا",
    "de_DE": "Monatliche Updates",
    "en_US": "Updates Monthly",
    "es_ES": "Se actualiza cada mes",
    "fr_FR": "Mise à jour mensuelle",
    "hi_IN": "Updates Monthly",
    "in_ID": "Pembaruan Bulanan",
    "ja_JP": "Updates Monthly",
    "ko_KR": "Updates Monthly",
    "ms_MY": "Dikemas Kini Setiap Bulan",
    "pt_PT": "Atualiza Mensalmente",
    "ru_RU": "Ежемесячные обновления",
    "th_TH": "อัปเดตประจำเดือน",
    "tr_TR": "Aylık Olarak Güncellenir",
    "vi_VN": "Cập Nhật Hàng Tháng",
    "zh_CN": "每月更新"
  },
  "club_achievement_overview_open": {
    "HK": "展開",
    "TW": "展開",
    "ar_SA": "توسيع",
    "de_DE": "Ausklappen",
    "en_US": "Expand",
    "es_ES": "Expandir",
    "fr_FR": "Afficher",
    "hi_IN": "Expand",
    "in_ID": "Selengkapnya",
    "ja_JP": "Expand",
    "ko_KR": "Expand",
    "ms_MY": "Kembang",
    "pt_PT": "Expandir",
    "ru_RU": "Развернуть",
    "th_TH": "ขยาย",
    "tr_TR": "Genişlet",
    "vi_VN": "Mở rộng",
    "zh_CN": "展开"
  },
  "club_achievement_overview_pop_condition_title": {
    "HK": "達成條件",
    "TW": "達成條件",
    "ar_SA": "المتطلبات",
    "de_DE": "Anforderungen",
    "en_US": "Requirements",
    "es_ES": "Requisitos",
    "fr_FR": "Conditions",
    "hi_IN": "Requirements",
    "in_ID": "Persyaratan",
    "ja_JP": "Requirements",
    "ko_KR": "Requirements",
    "ms_MY": "Syarat",
    "pt_PT": "Requisitos",
    "ru_RU": "Требования",
    "th_TH": "เงื่อนไข",
    "tr_TR": "Gereksinimler",
    "vi_VN": "Yêu cầu",
    "zh_CN": "达成条件"
  },
  "club_achievement_overview_pop_monthly": {
    "HK": "每月1日（UTC+0）更新",
    "TW": "每月1日（UTC+0）更新",
    "ar_SA": "يُحدّث في بداية كل شهر (بالتوقيت العالمي+0)",
    "de_DE": "Wird jeweils am 1. Tag des Monats aktualisiert (UTC±0)",
    "en_US": "Updates on the 1st of every month (UTC +0)",
    "es_ES": "Se actualiza el primer día de cada mes (UTC +0)",
    "fr_FR": "Mise à jour le 1er de chaque mois (UTC +0)",
    "hi_IN": "Updates on the 1st of every month (UTC +0)",
    "in_ID": "Diperbarui pada tanggal 1 setiap bulannya (UTC+0)",
    "ja_JP": "Updates on the 1st of every month (UTC +0)",
    "ko_KR": "Updates on the 1st of every month (UTC +0)",
    "ms_MY": "Dikemas kini pada hari pertama bagi setiap bulan (UTC +0)",
    "pt_PT": "Atualiza no dia 1 de cada mês (UTC +0)",
    "ru_RU": "Обновления 1 числа каждого месяца (UTC+0)",
    "th_TH": "อัปเดตทุกวันที่ 1 ของเดือน (UTC +0)",
    "tr_TR": "Her ayın 1'inde güncellenir (UTC +0)",
    "vi_VN": "Cập nhật vào ngày 1 hàng tháng (UTC +0)",
    "zh_CN": "每月1号UTC 0更新"
  },
  "club_achievement_overview_pop_ok": {
    "HK": "已達到",
    "TW": "已達到",
    "ar_SA": "مُنجز",
    "de_DE": "Erreicht",
    "en_US": "Achieved",
    "es_ES": "Logrado",
    "fr_FR": "Accompli",
    "hi_IN": "Achieved",
    "in_ID": "Tercapai",
    "ja_JP": "Achieved",
    "ko_KR": "Achieved",
    "ms_MY": "Dicapai",
    "pt_PT": "Conquistou",
    "ru_RU": "Получено",
    "th_TH": "สำเร็จแล้ว",
    "tr_TR": "Başarıyla Alındı",
    "vi_VN": "Đã đạt",
    "zh_CN": "已达到"
  },
  "club_achievement_overview_pop_reward_title": {
    "HK": "獎勵",
    "TW": "獎勵",
    "ar_SA": "المكافآت",
    "de_DE": "Belohnungen",
    "en_US": "Rewards",
    "es_ES": "Recompensas",
    "fr_FR": "Récompenses",
    "hi_IN": "Rewards",
    "in_ID": "Hadiah",
    "ja_JP": "Rewards",
    "ko_KR": "Rewards",
    "ms_MY": "Ganjaran",
    "pt_PT": "Recompensas",
    "ru_RU": "Награды",
    "th_TH": "รางวัล",
    "tr_TR": "Ödüller",
    "vi_VN": "Phần Thưởng",
    "zh_CN": "奖励"
  },
  "club_achievement_overview_pop_title": {
    "HK": "詳情",
    "TW": "詳情",
    "ar_SA": "التفاصيل",
    "de_DE": "Details",
    "en_US": "Details",
    "es_ES": "Detalles",
    "fr_FR": "Détails",
    "hi_IN": "Details",
    "in_ID": "Detail",
    "ja_JP": "Details",
    "ko_KR": "Details",
    "ms_MY": "Butiran",
    "pt_PT": "Detalhes",
    "ru_RU": "Детали",
    "th_TH": "รายละเอียด",
    "tr_TR": "Ayrıntılar",
    "vi_VN": "Chi Tiết",
    "zh_CN": "详情"
  },
  "club_achievement_overview_reward_10": {
    "HK": "頭像框：俱樂部頭像框（30天）",
    "TW": "頭像框：俱樂部頭像框（30天）",
    "ar_SA": "إطار الصورة الرمزية: إطار الصورة الرمزية للنادي (30 يومًا)",
    "de_DE": "Avatar-Rahmen: Club-Avatar-Rahmen (30d)",
    "en_US": "Avatar Frame: Club Avatar Frame (30d)",
    "es_ES": "Marco de Avatar: Marco de Avatar del Club (30 d)",
    "fr_FR": "Cadre d'avatar : Cadre d'avatar du Club (30 j)",
    "hi_IN": "Avatar Frame: Club Avatar Frame (30d)",
    "in_ID": "Bingkai Avatar: Bingkai Avatar Club (30h)",
    "ja_JP": "Avatar Frame: Club Avatar Frame (30d)",
    "ko_KR": "Avatar Frame: Club Avatar Frame (30d)",
    "ms_MY": "Bingkai Avatar: Bingkai Avatar Kelab (30h)",
    "pt_PT": "Moldura de Avatar: Moldura de Avatar do Clube (30 d)",
    "ru_RU": "Рамка клуба (30 д.)",
    "th_TH": "กรอบรูป: กรอบรูปคลับ (30D)",
    "tr_TR": "Avatar Çerçevesi: Kulüp Avatar Çerçevesi (30g)",
    "vi_VN": "Khung Ảnh Đại Diện: Khung Ảnh Đại Diện Câu Lạc Bộ (30 Ngày)",
    "zh_CN": "头像框:CLUB头像框(30天)"
  },
  "club_achievement_overview_reward_11": {
    "HK": "稱號：俱樂部名人（永久）",
    "TW": "稱號：俱樂部名人（永久）",
    "ar_SA": "لقب: نجم النادي (دائم)",
    "de_DE": "Titel: Club-Star (Permanent)",
    "en_US": "Title: Club Star (Permanent)",
    "es_ES": "Título: Estrella del Club (permanente)",
    "fr_FR": "Titre : Star du Club (permanent)",
    "hi_IN": "Title: Club Star (Permanent)",
    "in_ID": "Gelar: Club Star (Permanen)",
    "ja_JP": "Title: Club Star (Permanent)",
    "ko_KR": "Title: Club Star (Permanent)",
    "ms_MY": "Gelaran: Bintang Kelab (Kekal)",
    "pt_PT": "Título: Estrela do Clube (Permanente)",
    "ru_RU": "Титул «Звезда клуба» (постоянный)",
    "th_TH": "ฉายา: Club Star (ถาวร)",
    "tr_TR": "Unvan: Kulübün Yıldızı (Kalıcı)",
    "vi_VN": "Danh Hiệu: Ngôi Sao Câu Lạc Bộ (Vĩnh Viễn)",
    "zh_CN": "称号:俱乐部名人 (永久)"
  },
  "club_achievement_overview_reward_12": {
    "HK": "稱號：俱樂部超級巨星（永久）",
    "TW": "稱號：俱樂部超級巨星（永久）",
    "ar_SA": "لقب: نجم النادي المتألق (دائم)",
    "de_DE": "Titel: Club-Megastar (Permanent)",
    "en_US": "Title: Club Megastar (Permanent)",
    "es_ES": "Título: Megaestrella del Club (permanente)",
    "fr_FR": "Titre : Mégastar du Club (permanent)",
    "hi_IN": "Title: Club Megastar (Permanent)",
    "in_ID": "Gelar: Club Megastar (Permanen)",
    "ja_JP": "Title: Club Megastar (Permanent)",
    "ko_KR": "Title: Club Megastar (Permanent)",
    "ms_MY": "Gelaran: Bintang Mega Kelab (Kekal)",
    "pt_PT": "Título: Megaestrela do Clube (Permanente)",
    "ru_RU": "Титул «Мегазвезда клуба» (постоянный)",
    "th_TH": "ฉายา: Club Megastar (ถาวร)",
    "tr_TR": "Unvan: Kulübün Megastarı (Kalıcı)",
    "vi_VN": "Danh Hiệu: Ngôi Sao Siêu Cấp Câu Lạc Bộ (Vĩnh Viễn)",
    "zh_CN": "称号:俱乐部超级巨星 (永久)"
  },
  "club_achievement_overview_reward_6": {
    "HK": "稱號：俱樂部新星（永久）",
    "TW": "稱號：俱樂部新星（永久）",
    "ar_SA": "لقب: نجم النادي الصاعد (دائم)",
    "de_DE": "Titel: Aufsteigender Clubstern (Permanent)",
    "en_US": "Title: Club Rising Star (Permanent)",
    "es_ES": "Título: Estrella en Ascenso del Club (permanente)",
    "fr_FR": "Titre : Étoile montante du Club (permanent)",
    "hi_IN": "Title: Club Rising Star (Permanent)",
    "in_ID": "Gelar: Club Rising Star (Permanen)",
    "ja_JP": "Title: Club Rising Star (Permanent)",
    "ko_KR": "Title: Club Rising Star (Permanent)",
    "ms_MY": "Gelaran: Bintang Baharu Kelab (Kekal)",
    "pt_PT": "Título: Estrela em Ascensão do Clube (Permanente)",
    "ru_RU": "Титул «Восходящая звезда клуба» (постоянный)",
    "th_TH": "ฉายา: ดาวรุ่งคลับ (ถาวร)",
    "tr_TR": "Unvan: Kulübün Yükselen Yıldızı (Kalıcı)",
    "vi_VN": "Danh Hiệu: Ngôi Sao Mới Câu Lạc Bộ (Vĩnh Viễn)",
    "zh_CN": "称号:俱乐部新星 (永久)"
  },
  "club_achievement_overview_reward_7": {
    "HK": "稱號：俱樂部萬人迷（永久）",
    "TW": "稱號：俱樂部萬人迷（永久）",
    "ar_SA": "لقب: نجم النادي اللامع (دائم)",
    "de_DE": "Titel: Club-Superstar (Permanent)",
    "en_US": "Title: Club Superstar (Permanent)",
    "es_ES": "Título: Superestrella del Club (permanente)",
    "fr_FR": "Titre : Superstar du Club (permanent)",
    "hi_IN": "Title: Club Superstar (Permanent)",
    "in_ID": "Gelar: Club Superstar (Permanen)",
    "ja_JP": "Title: Club Superstar (Permanent)",
    "ko_KR": "Title: Club Superstar (Permanent)",
    "ms_MY": "Gelaran: Bintang Super Kelab (Kekal)",
    "pt_PT": "Título: Superestrela do Clube (Permanente)",
    "ru_RU": "Титул «Суперзвезда клуба» (постоянный)",
    "th_TH": "ฉายา: ซุปเปอร์สตาร์คลับ (ถาวร)",
    "tr_TR": "Unvan: Kulübün Süperstarı (Kalıcı)",
    "vi_VN": "Danh Hiệu: Siêu Sao Câu Lạc Bộ (Vĩnh Viễn)",
    "zh_CN": "称号:俱乐部万人迷(永久)"
  },
  "club_achievement_overview_reward_8": {
    "HK": "稱號：妙語連珠（30天）",
    "TW": "稱號：妙語連珠（30天）",
    "ar_SA": "لقب: الفصيح (30 يومًا)",
    "de_DE": "Titel: Silberzunge (30d)",
    "en_US": "Title: Silver-Tongued (30d)",
    "es_ES": "Título: Elocuente (30 d)",
    "fr_FR": "Titre : Langue d'argent (30 j)",
    "hi_IN": "Title: Silver-Tongued (30d)",
    "in_ID": "Title: Silver-Tongued (30h)",
    "ja_JP": "Title: Silver-Tongued (30d)",
    "ko_KR": "Title: Silver-Tongued (30d)",
    "ms_MY": "Gelaran: Fasih (30h)",
    "pt_PT": "Titulo: Eloquente (30 d)",
    "ru_RU": "Титул «Красноречие» (30 д.)",
    "th_TH": "ฉายา: ลิ้นทองคำ (30D)",
    "tr_TR": "Unvan: Söz Sahibi (30g)",
    "vi_VN": "Danh Hiệu: Ăn Nói Khéo Léo (30 Ngày)",
    "zh_CN": "称号:妙语连珠 (30天)"
  },
  "club_achievement_overview_reward_9": {
    "HK": "資訊卡：魅力十足（30天）",
    "TW": "資訊卡：魅力十足（30天）",
    "ar_SA": "بطاقة المعلومات: الفتنة الطاغية (30 يومًا)",
    "de_DE": "Infokarte: Zauberhafter Reiz (30d)",
    "en_US": "Info Card: Charming Allure (30d)",
    "es_ES": "Tarjeta de Información: Entorno Encantador (30 d)",
    "fr_FR": "Carte d'infos : Atmosphère charmante (30 j)",
    "hi_IN": "Info Card: Charming Allure (30d)",
    "in_ID": "Kartu Info: Charming Allure (30h)",
    "ja_JP": "Info Card: Charming Allure (30d)",
    "ko_KR": "Info Card: Charming Allure (30d)",
    "ms_MY": "Kad Maklumat: Godaan Anggun (30h)",
    "pt_PT": "Cartão de Informações: Atração Encantadora (30 d)",
    "ru_RU": "Карта данных «Очаровательный шарм» (30 д.)",
    "th_TH": "บัตรข้อมูล: เจ้าเสน่ห์ (30D)",
    "tr_TR": "Bilgi Kartı: Büyüleyen Cazibe (30g)",
    "vi_VN": "Thẻ Thông Tin: Vô Cùng Quyến Rũ (30 Ngày)",
    "zh_CN": "信息卡:魅力十足(30天)"
  },
  "club_achievement_overview_tips": {
    "HK": "完成成就以解鎖稱號、頭像框等獎勵，點擊查看",
    "TW": "完成成就以解鎖稱號、頭像框等獎勵，點按查看",
    "ar_SA": "أكمل الإنجازات لتحرير مكافآت سخية مثل الألقاب وإطارات الصور الرمزية! اضغط لمزيد من التفاصيل.",
    "de_DE": "Schließe Achievements ab, um Belohnungen freizuschalten, wie z. B. Titel und Avatar-Rahmen! Zum Ansehen tippen.",
    "en_US": "Complete achievements to unlock rewards like Titles and Avatar Frames! Tap to view.",
    "es_ES": "¡Completa logros para desbloquear recompensas como Títulos y Marcos de Avatar! Toca para ver más.",
    "fr_FR": "Accomplissez des succès pour débloquer des récompenses uniques ! Appuyez pour plus de détails.",
    "hi_IN": "Complete achievements to unlock rewards like Titles and Avatar Frames! Tap to view.",
    "in_ID": "Raih prestasi untuk membuka hadiah, seperti Gelar dan Bingkai Avatar! Tekan untuk melihat.",
    "ja_JP": "Complete achievements to unlock rewards like Titles and Avatar Frames! Tap to view.",
    "ko_KR": "Complete achievements to unlock rewards like Titles and Avatar Frames! Tap to view.",
    "ms_MY": "Lengkapkan pencapaian untuk membuka ganjaran seperti Gelaran dan Bingkai Avatar! Ketik untuk melihat.",
    "pt_PT": "Obtenha conquistas para desbloquear recompensas como Títulos e Molduras de Avatar! Toque para ver.",
    "ru_RU": "Получайте достижения, чтобы открыть такие награды как титулы и рамки аватара! Нажмите, чтобы узнать подробнее.",
    "th_TH": "บรรลุความสำเร็จเพื่อปลดล็อครางวัล อย่างเช่น ฉายาและกรอบรูป! แตะเพื่อดู",
    "tr_TR": "Unvan ve Avatar Çerçevesi gibi ödüllerin kilidini açmak için başarımları tamamla! Görüntülemek için dokun.",
    "vi_VN": "Hoàn thành thành tích để mở khóa thưởng Danh Hiệu và Khung Ảnh Đại Diện! Nhấn để xem.",
    "zh_CN": "完成成就解锁称号、头像框等奖励，点击查看"
  },
  "club_achievement_overview_title": {
    "HK": "我的成就",
    "TW": "我的成就",
    "ar_SA": "إنجازاتي",
    "de_DE": "Meine Achievements",
    "en_US": "My Achievements",
    "es_ES": "Mis logros",
    "fr_FR": "Mes succès",
    "hi_IN": "My Achievements",
    "in_ID": "Prestasi Saya",
    "ja_JP": "My Achievements",
    "ko_KR": "My Achievements",
    "ms_MY": "Pencapaian Saya",
    "pt_PT": "Minhas Conquistas",
    "ru_RU": "Мои достижения",
    "th_TH": "ความสำเร็จของฉัน",
    "tr_TR": "Başarımlarım",
    "vi_VN": "Thành Tích Của Tôi",
    "zh_CN": "我的成就"
  },
  "club_achievement_personal": {
    "HK": "個人成就",
    "TW": "個人成就",
    "ar_SA": "إنجازات شخصية",
    "de_DE": "Persönliche Achievements",
    "en_US": "Personal Achievements",
    "es_ES": "Personal Achievements",
    "fr_FR": "Succès personnels",
    "hi_IN": "Personal Achievements",
    "in_ID": "Prestasi Pribadi",
    "ja_JP": "個人の実績",
    "ko_KR": "개인 업적",
    "ms_MY": "Pencapaian Peribadi",
    "pt_PT": "Conquistas Pessoais",
    "ru_RU": "Персональные достижения",
    "th_TH": "ความสำเร็จส่วนตัว",
    "tr_TR": "Kişisel Başarımlar",
    "vi_VN": "Thành Tích Cá Nhân",
    "zh_CN": "个人成就"
  },
  "club_achievement_policy": {
    "HK": "隱藏我的成就資訊",
    "TW": "隱藏我的成就資訊",
    "ar_SA": "إخفاء إنجازاتي عن الآخرين",
    "de_DE": "Meine Achievements vor anderen verbergen",
    "en_US": "Hide my achievements from others",
    "es_ES": "Ocultar mis logros de otros",
    "fr_FR": "Ne pas montrer mes succès aux autres",
    "hi_IN": "Hide my achievements from others",
    "in_ID": "Sembunyikan prestasi dari orang lain",
    "ja_JP": "自分の実績を他の人から隠す",
    "ko_KR": "내 업적을 다른 사람에게 숨기기",
    "ms_MY": "Sembunyikan pencapaian saya daripada pemain lain",
    "pt_PT": "Esconder minhas conquistas dos outros",
    "ru_RU": "Скрыть мои достижения от остальных",
    "th_TH": "ซ่อนความสำเร็จของฉันจากคนอื่นๆ",
    "tr_TR": "Başarımlarımı diğerlerinden gizle",
    "vi_VN": "Ẩn Thông Tin Thành Tích",
    "zh_CN": "隐藏我的成就信息"
  },
  "club_rank_setting_cancel": {
    "HK": "取消",
    "TW": "取消",
    "ar_SA": "إلغاء",
    "de_DE": "Abbrechen",
    "en_US": "Cancel",
    "es_ES": "Cancelar",
    "fr_FR": "Annuler",
    "hi_IN": "Cancel",
    "in_ID": "Batalkan",
    "ja_JP": "キャンセル",
    "ko_KR": "취소",
    "ms_MY": "Batal",
    "pt_PT": "Cancelar",
    "ru_RU": "Отмена",
    "th_TH": "ยกเลิก",
    "tr_TR": "İptal",
    "vi_VN": "Hủy",
    "zh_CN": "取消"
  },
  "club_rank_setting_confirm": {
    "HK": "確認",
    "TW": "確定",
    "ar_SA": "تأكيد",
    "de_DE": "Bestätigen",
    "en_US": "Confirm",
    "es_ES": "Aceptar",
    "fr_FR": "Confirmer",
    "hi_IN": "Confirm",
    "in_ID": "Konfirmasi",
    "ja_JP": "確認",
    "ko_KR": "확인하다",
    "ms_MY": "Sahkan",
    "pt_PT": "Confirmar",
    "ru_RU": "Подтвердить",
    "th_TH": "ยืนยัน",
    "tr_TR": "Onayla",
    "vi_VN": "Đồng ý",
    "zh_CN": "确认"
  },
  "club_rank_setting_title": {
    "HK": "私隱設定",
    "TW": "隱私設定",
    "ar_SA": "إعدادات الخصوصية",
    "de_DE": "Datenschutz-Einstellungen",
    "en_US": "Privacy Settings",
    "es_ES": "Configuración de privacidad",
    "fr_FR": "Paramètres de confidentialité",
    "hi_IN": "Privacy Settings",
    "in_ID": "Pengaturan Privasi",
    "ja_JP": "プライバシー設定",
    "ko_KR": "개인 정보 설정",
    "ms_MY": "Tetapan Privasi",
    "pt_PT": "Ajustes de Privacidade",
    "ru_RU": "Настройки конфиденциальности",
    "th_TH": "ตั้งค่าความเป็นส่วนตัว",
    "tr_TR": "Gizlilik Ayarları",
    "vi_VN": "Cài Đặt Quyền Riêng Tư",
    "zh_CN": "隐私设置"
  }
}